// extracted by mini-css-extract-plugin
module.exports = {"changePasswordContainer":"ChangePassword_changePasswordContainer__2HwfK","changePasswordButtonSpinner":"ChangePassword_changePasswordButtonSpinner__2rG6k"};